'use client';

import { cn } from '@coas/ui/lib';
import type { SexSchema } from '@coas/validators/const';
import { useAtom } from 'jotai';
import type { PropsOf } from '~/shared/lib';
import { categoryStateAtom } from '../model/state';

type SidebarTriggerProps = Omit<PropsOf<'button'>, 'onClick'> & {
    sex?: SexSchema;
};

export const CategoryTrigger = (props: SidebarTriggerProps) => {
    const [{ sex }, setState] = useAtom(categoryStateAtom);

    return (
        <button
            {...props}
            className={cn(
                'px-page pt-1 font-700 text-14 text-neutral-50 uppercase',
                sex === props.sex ? 'bg-neutral-600' : 'hover:bg-neutral-700',
            )}
            onClick={() => {
                setState(prev => ({ ...prev, sex: props.sex ?? prev.sex }));
            }}
        />
    );
};
